<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

:root {
  * {
    background-color: #f9fafb;
    color: black;
    font-family: "Roboto", sans-serif;
  }
}
</style>
